<script lang="ts">
  import SkeletonProductCards from "@shared/svelte/Components/ProductLines/Skeletons/SkeletonProductCards.svelte";
  import LayoutStore from "@shared/svelte/Stores/LayoutStore";
  import CardCarousel from "@shared/svelte/Components/Carousel/CardCarousel.svelte";
  import CarouselTitle from "@shared/svelte/Components/Carousel/CarouselTitle.svelte";
  import { HttpPromise } from "@shared/svelte/Modules/ApiService";
  import TrackingContext from "@shared/svelte/Components/Tracking/TrackingContext.svelte";

  export let endpoint: string;
  export let forwardLink: string = "";
  export let headerText: string;
  export let id: string;
  export let outsideContainer: boolean = false;
  export let pageName: string;
  export let pageValue: string | null = null;
  export let recommendationMethod: string | null = null;
  export let recommendationAttrs: any = {};
  export let withoutMatchedDistributor: boolean = false;
  export let sponsoredFlag: boolean = false;
  export let shortenHeaderTextOnMobile: boolean = true;
  export let carouselCardsShown: number = 5;
  export let carouselDataProps: any = null;
  export let otherEntities: any = null;
  export let productLinePriceBucket: number | null = null;

  // unused import from DiscoveryPanel.svelte
  export let mobileMode: boolean = false;
  mobileMode;

  let loaded: boolean = false;
  let placements = [];
  let priceSegmentationBuckets: number[] | null = recommendationAttrs.price_buckets;

  const carouselData = () => {
    const data: any = {
      carousel: `${id}_carousel`,
      page_name: pageName,
    };

    if (pageValue) {
      data.page_value = pageValue;
    }

    if (carouselDataProps) {
      Object.keys(carouselDataProps).forEach(key => {
        data[key] = carouselDataProps[key];
      });
    }

    if (recommendationMethod) {
      data.recommendation_method = recommendationMethod;
    }

    if (Object.keys(recommendationAttrs).length) {
      data.recommendation_attrs = JSON.stringify(recommendationAttrs);
    }

    if (withoutMatchedDistributor) {
      data.without_matched_distributor = withoutMatchedDistributor;
    }

    return data;
  };

  HttpPromise({
    method: "GET",
    url: `/api/retailer/carousel_placements/${endpoint}`,
    data: carouselData(),
  })
    .then(res => {
      loaded = true;
      placements = res.placements;

      // This will come in discovery panel config once search service powers best sellers
      if (res.price_segmentation_buckets) {
        priceSegmentationBuckets = res.price_segmentation_buckets;
      }

      if (res.product_line_price_bucket) {
        productLinePriceBucket = res.product_line_price_bucket;
      }
    })
    .catch(() => (placements = []));

  // set the container width
  $: containerWidth = outsideContainer ? `1440px` : `100%`;
</script>

{#if !loaded}
  <div class={`fizz-styles {id}-carousel`} class:fizz-container={outsideContainer}>
    <div
      class:fizz-stack-32={outsideContainer}
      class:fizz-inset-horizontal-16={$LayoutStore.isMobile && outsideContainer}
      class:fizz-inset-horizontal-32={$LayoutStore.isDesktop && outsideContainer}
      style="max-width: {containerWidth}"
    >
      <CarouselTitle
        carouselName={headerText}
        {forwardLink}
        shortenNameOnMobile={shortenHeaderTextOnMobile}
        {sponsoredFlag}
      />
      <SkeletonProductCards {outsideContainer} perViewCards={carouselCardsShown} />
    </div>
  </div>
{:else if placements.length}
  <TrackingContext entities={otherEntities}>
    <CardCarousel
      {carouselCardsShown}
      productLines={placements}
      carouselIdentifier={id}
      carouselName={headerText}
      {outsideContainer}
      {forwardLink}
      {priceSegmentationBuckets}
      {productLinePriceBucket}
      shortenNameOnMobile={shortenHeaderTextOnMobile}
      {sponsoredFlag}
    />
  </TrackingContext>
{/if}
